module.exports = __webpack_public_path__ + "img/domestic-1986-good-news.4d208141.jpg";